import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SectionComponent } from './section.component';
import { SectionService } from './section.service';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';

@NgModule({
    imports: [
        CommonModule,
        FontIconModule,
    ],
    declarations: [
        SectionComponent
    ],
    providers: [
        SectionService
    ],
    exports: [
        SectionComponent
    ]
})
export class SectionModule {}
